import { useQuery } from "@tanstack/react-query";
import { communityApi } from "@bw/shared/api";
import type { CommunityResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The facility's single active community (GET /communities/facility/{id}),
 * returned VERBATIM as `CommunityResponse | null` — a 200 + null body when the
 * facility has no community yet (NOT a 404). Backs the SECONDARY
 * FacilityCommunityCard on the drop-in/facility detail page: it surfaces the
 * club if one exists and routes into /community/communities/:id (which owns
 * join/leave + feed). No derived state, no join logic here — thin presentation.
 *
 * Disabled until a facilityId is present so an unresolved route param never
 * fires a bogus request. Cached under the `dropin.facilityCommunity(id)` key.
 * Mirrors the social module's useCommunity shape.
 */
export function useFacilityCommunity(facilityId: string) {
  return useQuery<CommunityResponse | null>({
    queryKey: queryKeys.dropin.facilityCommunity(facilityId),
    queryFn: () => communityApi.getFacilityCommunity(facilityId),
    enabled: Boolean(facilityId),
  });
}
